/**
 * Función que crea una capa de tipo WMS a partir de una URL
 * @returns {TileLayer} Capa de tipo WMS
 */

import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'


export function layerWMS(props) {
    const {
        name,
        title,
        image,
        type,
        visible = false,
        url,
        attributions = false,
        opacity = 1.0,
        params = null,
        responseInfoFormat = 'text/html',
        queryable = true,
        tematica = false,
        group = null,
        minZoom = null,
        maxZoom = null,
      } = props;

    // Obtener versión WMS con valor por defecto (params puede ser null o no tener version)
    const wmsVersion = (params && params.version) ? params.version : '1.1.1';

    // Build WMS params: start with required LAYERS/VERSION, then spread all stored params
    // (uppercasing keys so CQL_FILTER, STYLES, etc. follow the WMS standard)
    const wmsParams = { LAYERS: name, VERSION: wmsVersion };
    if (params && typeof params === 'object' && !Array.isArray(params)) {
        Object.entries(params).forEach(([key, value]) => {
            const upperKey = key.toUpperCase();
            if (upperKey !== 'LAYERS' && upperKey !== 'VERSION') {
                wmsParams[upperKey] = value;
            }
        });
    }
    // Build layer options
    const layerOptions = {
      name,
      title,
      image,
      type,
      visible,
      queryable,
      opacity,
      tematica,
      group,
      responseInfoFormat,
    };

    // Only add minZoom/maxZoom if they are valid numbers
    if (minZoom !== null && minZoom !== undefined && !isNaN(Number(minZoom))) {
      layerOptions.minZoom = Number(minZoom);
    }
    if (maxZoom !== null && maxZoom !== undefined && !isNaN(Number(maxZoom))) {
      layerOptions.maxZoom = Number(maxZoom);
    }

    layerOptions.source = new TileWMS({
        url,
        params: wmsParams,
        crossOrigin: 'anonymous',
        attributions
      });

    const wmsLayer = new TileLayer(layerOptions);
    return wmsLayer;
  }